export default {
	state: () => ({
		contentGateIsShown: false,
		bookmarksConnected : false, 
	}),
	getters: {
		getContentGateIsShown: state => {
			return state.contentGateIsShown;
		},
		getBookmarksConnected: state => {
			return state.bookmarksConnected;
		},
	},
	mutations: {
		setContentGateIsShown: (state, isShown) => {
			state.contentGateIsShown = isShown;
		},
		setBookmarksConnected: (state, option) => {
			state.bookmarksConnected = option;
		},
	},
};
